import script from "./CustomSwiper.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomSwiper.vue?vue&type=script&setup=true&lang=js"

import "./CustomSwiper.vue?vue&type=style&index=0&id=a48ff8f2&lang=scss"

const __exports__ = script;

export default __exports__